import { Component } from '@angular/core';
import { BaseComponent } from '../core/base/base.component';
import { FORBIDDEN_CONSTANTS } from './forbidden.constants';
import { ForbiddenService } from './forbidden.service';

@Component({
  selector: 'ms-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenViewComponent extends BaseComponent {

  override screen = FORBIDDEN_CONSTANTS;
  override setScreen = true;

  constructor(override service: ForbiddenService) {
    super();
  }

}
